function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { useQuery } from '@apollo/client';
import classNames from 'classnames';
import FormManager from '../FormManager';
import Icon from '../Icon';
import EditorField from '../Fields/EditorField';
import { useSession } from '../Session';
import Toaster from '../Toaster';
import PreventDragButton from '../PreventDragButton';
import { useAuthAPI } from '../../common/hooks/useAuthAPI';
import branding from '@config/branding';
import Loader from '../Loader';
import { useHistory } from 'react-router-dom';
import HelpTextModal from './Modal';
import HelpTextProvider from './Provider';
import HelpTextField from './Field';
import { HelpTextScreenQuery } from './graphql';
import './index.scss';

const HelpText = ({
  groupName,
  fieldName,
  customURL,
  removeModalTrapFocus,
  modalClassName,
  customPermission,
  className,
  children,
  ...props
}) => {
  const history = useHistory();
  const location = history?.location || window.location;
  const pageURL = customURL ? customURL : location.pathname + location.hash;
  const [{
    user
  }] = useSession();
  const request = useAuthAPI('/api/HelpText');
  const requestData = useQuery(HelpTextScreenQuery, {
    fetchPolicy: 'cache-first',
    // notifyOnNetworkStatusChange: true,
    variables: {
      applicationAreaID: branding.applicationAreaID,
      pageURL
    }
  });
  const permissionToEdit = user?.devUser || customPermission;
  const data = requestData.data?.screen;

  const handleSave = event => {
    event.originalEvent?.stopPropagation();

    if (event.isReady()) {
      const FORM_DATA = event.json();
      const payload = {
        "id": 0,
        "applicationAreaID": branding.applicationAreaID,
        "pageURL": pageURL,
        "fieldName": fieldName || pageURL,
        "groupName": groupName,
        "title": FORM_DATA.title,
        "content": FORM_DATA.content
      };
      const toast = Toaster(`Saving Help Text ${FORM_DATA.title}`);
      request.call({
        data: payload
      }).then(response => {
        if (response.data.success) {
          event.setDirty(false);
          requestData.refetch();
          toast.success(`Successfully saved ${FORM_DATA.title}`); //@ts-ignore
          // event.originalEvent?.target?.closest('.help-text-modal')?.querySelector('.help-text-close')?.click()
        } else {
          FormManager.setBackendValidation(event, response.data.errors);
          toast.fail(response.data.message || branding.messages.fail);
        }
      }).catch(error => {
        toast.error(error?.response.data?.message || branding.messages.error);
      });
    }
  };

  const isDev = permissionToEdit;
  return isDev || !!data ? /*#__PURE__*/React.createElement(HelpTextModal, _extends({
    removeModalTrapFocus: removeModalTrapFocus,
    modalClassName: classNames(modalClassName || '', {
      dev: isDev
    }),
    className: className,
    permissionToEdit: permissionToEdit
  }, props, {
    modalBody: /*#__PURE__*/React.createElement(React.Fragment, null, isDev ? /*#__PURE__*/React.createElement(FormManager, {
      id: "help-text-form",
      onSubmit: handleSave
    }, /*#__PURE__*/React.createElement(PreventDragButton, {
      as: "div"
    }, /*#__PURE__*/React.createElement(FormManager.Input, {
      name: "title",
      placeholder: "Enter title",
      value: data?.Title
    }), /*#__PURE__*/React.createElement(FormManager.Input, {
      as: EditorField,
      name: "content",
      value: data?.Content
    })), /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-end"
    }, /*#__PURE__*/React.createElement(PreventDragButton, {
      type: "submit",
      form: "help-text-form",
      loading: request.loading
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "save"
    }), " Save"), /*#__PURE__*/React.createElement(PreventDragButton, {
      type: "button",
      variant: "secondary",
      className: "ml-2",
      disabled: request.loading,
      onClick: e => {
        e.target?.closest('.help-text-modal')?.querySelector('.help-text-close')?.click();
      }
    }, "Cancel"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "help-text-title"
    }, data?.Title), /*#__PURE__*/React.createElement("div", {
      className: "help-text-content",
      dangerouslySetInnerHTML: {
        __html: data?.Content || ""
      }
    })), /*#__PURE__*/React.createElement(Loader, {
      active: requestData.loading
    }, /*#__PURE__*/React.createElement("small", {
      className: "mt-4"
    }, "Loading the Help Text data...")))
  }), children) : null;
};

HelpText.Modal = HelpTextModal;
HelpText.Provider = HelpTextProvider;
HelpText.Field = HelpTextField;
export default HelpText;